import { Navigate, Outlet, useLocation } from 'react-router-dom';

// --- Component 1: Checks Login Only ---
export const ProtectedRoute = ({
  isAuthenticated,
  redirectPath = '/login-or-signup',
}: ProtectedRoutesBaseProps) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

// --- Component 2: Checks Role Only ---
// Note: We don't need to check isAuthenticated here if we nest them correctly!
export const AdminRoute = ({
  isAuthenticated,
  isStaff,
  redirectPath = '/',
}: ProtectedRoutesAdminProps) => {
  if (!isStaff || !isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

// --- 3. Guest Route (Restricts Logged-in Users) ---
// Use named export for consistency
// Keep GuestRoute simple for login/signup pages
export const GuestRoute = ({
  isAuthenticated,
  hasProfile,
  isNewUser,
  redirectPath = '/',
}: ProtectedRoutesGuestProps) => {
  // If user is logged in
  if (isAuthenticated) {
    // Check if they need to complete profile first
    if (isNewUser && !hasProfile) {
      return <Navigate to="/create-profile" replace />;
    }
    // Otherwise redirect to home or specified path
    return <Navigate to={redirectPath} replace />;
  }
  
  return <Outlet />;
};

// --- 4.Specific Route for Create Profile Flow---
export const ProfileCreationRoute = ({
  isAuthenticated,
  hasProfile,
  isNewUser,
  redirectPath = '/',
}: ProfileCreationRouteProps) => {

  // Only allow access if: logged in AND new user AND no profile
  const shouldAllowAccess = isAuthenticated && isNewUser && !hasProfile;

  return shouldAllowAccess ? (
    <Outlet />
  ) : (
    <Navigate to={redirectPath} replace />
  );
};
